import {
	createMuiTheme
} from '@material-ui/core'

const muiTheme = createMuiTheme({
	typography: {
		useNextVariants: true
	},
	overrides: {
		MuiIconButton: {
			root: {
				color: 'inherit'
			}
		},
		/* Fixes iOS display of icons */
		MuiIcon: {
			root: {
				lineHeight: '24px'
			}
		}
	}
})

export default muiTheme



// WEBPACK FOOTER //
// ./src/muiTheme.js